import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import { connect } from "react-redux";
import uniqBy from "lodash/uniqBy";
import {injectIntl} from "react-intl";

import {setRelatedGroups} from "../../../actions/selectionFunctions";
import FeatureInfoAssociatedProduct from "./featureInfoAssociatedProduct";
import {getBvFeatures} from "../../../api/server-api";
import {createRelatedGroups, getFilteredRelatedFeatures, getRelatedFeaturesFromLayout} from "../../../misc/helpers";
import LoadingSpinner from "../../ui/loadingSpinner";
import {getCurrentLayout} from "../../appLayout";

class FeatureInfoAssociatedProducts extends Component {

  static propTypes = {
    selectionFeatureInfo: PropTypes.object.isRequired,
    handleFeatureClick: PropTypes.func.isRequired,
  };

  state = {
    isLoading: false,
    relatedFeaturesRequestMade: false,
    activeDbFeatureId: 0,
  };

  componentDidMount() {
    // console.log("selectionFeatureInfo", this.props.selectionFeatureInfo);
    this.setRelatedGroups();
  }

  componentWillUnmount() {
    // console.log("selectionFeatureInfo", this.props.selectionFeatureInfo);
    this.props.setRelatedGroups([]);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // console.log("selectionFeatureInfo", this.props.selectionFeatureInfo);
    if (nextProps.relatedGroupsSearch !== this.props.relatedGroupsSearch
      || (nextProps.intl && this.props.intl && (nextProps.intl.locale !== this.props.intl.locale))) {
      this.setRelatedGroups(nextProps);
    }
  }

  getLoadedFeatures = (nextProps) => {
    let {noFeaturesFound, relatedFeaturesFound} = getRelatedFeaturesFromLayout(
      nextProps.selectionFeatureInfo.getFeatureRelatedFeatures(), nextProps.selectionFeatureInfo
    );
    if (noFeaturesFound.length && !this.state.relatedFeaturesRequestMade) {
      this.setState({
        isLoading: true
      });
      getBvFeatures(noFeaturesFound)
        .then(response => {
          const layout = getCurrentLayout();
          layout.loadNewFeatures(response.data);
          this.setState({
            isLoading: false,
            relatedFeaturesRequestMade: true
          });
          this.setRelatedGroups(this.props);
        });
    }
    relatedFeaturesFound = getFilteredRelatedFeatures(relatedFeaturesFound);
    return uniqBy(relatedFeaturesFound, (feature) => feature.dbFeature.id)
  };

  setRelatedGroups = (nextProps = this.props) => {
    const {intl, fabricatorData} = nextProps;
    const relatedFeatures = this.getLoadedFeatures(nextProps);
    // console.log("relatedGroups", relatedGroups);
    this.props.setRelatedGroups(createRelatedGroups(relatedFeatures, nextProps.cartItems, nextProps.activeQuoteIndex, intl, fabricatorData));
  };

  handleFeatureClick = (relatedFeature) => {
    this.setState({
      activeDbFeatureId: relatedFeature.part.dbFeature.id
    });
    if (relatedFeature.part.getParent && relatedFeature.part.getParent().disabled) {
      const itemParent = relatedFeature.part.getParent();
      if (itemParent.disabled) {
        itemParent.disabled = false;
        itemParent.disabledClick(); // disable also related parts
      }
    }
    this.props.handleFeatureClick(relatedFeature)
  };

  render() {
    // console.log("this.props.relatedGroups", this.props.relatedGroups);
    return (
      <ul className="prod-associated">
        {this.state.isLoading ? <LoadingSpinner/> : this.props.relatedGroups.map((relatedGroup, relatedGroupIndex) => {
          return (
            <li className="associated" key={relatedGroupIndex}>
              <h4 className="associated-title">{relatedGroup.name}</h4>
              {relatedGroup.relatedFeatures.map((relatedFeature, subItemIndex) => {
                return <FeatureInfoAssociatedProduct handleFeatureClick={this.handleFeatureClick}
                                                     isActive={this.state.activeDbFeatureId === relatedFeature.dbFeature.id}
                                                     relatedFeature={relatedFeature}
                                                     key={subItemIndex}/>
              })}
            </li>
          )
        })}
      </ul>
    )
  }
}

const mapStateToProps = (store) => {
  return {
    relatedGroups: store.selectionState.relatedGroups,
    relatedGroupsSearch: store.selectionState.relatedGroupsSearch,
    selectionFeatureInfo: store.selectionState.selectionFeatureInfo,
    cartItems: store.cartState.cartItems,
    fabricatorData: store.fabricatorState,
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
  };
};
const mapDispatchToProps = {
  setRelatedGroups
};
export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(FeatureInfoAssociatedProducts)
);
